import { SDKDataResponse } from "@/types";
import { API_URL } from "./const";

export const getProjectSDK = async (
  apiKey: string
): Promise<SDKDataResponse> => {
  const response = await fetch(`${API_URL}/projects/sdk?apiKey=${apiKey}`);
  return response.json();
};
